import { BaseApiDTO } from '@shared/dto/BaseApiDTO';
import { Gender } from '../groups/groups.dto';
import { DocumentSignaturesDTO } from '@shared/dto/signatures.dto';
import { InjectionToken } from '@angular/core';
import { BaseApiService } from '@shared/services/apiService/base-api.service';

export interface DocumentsApiDTO extends BaseApiDTO {
  state?: DocumentsState;
  categoryId?: string;
  spiceId?: string;

  serializedJson?: any;
  signatures?: DocumentSignaturesDTO[];

  documentCode?: string;
  quantity: number;
  startDate?: Date;
  endDate?: Date;
  gender?: Gender;
  description?: string;
  origin?: string;
  destination?: string;
  //user role data
  vetId?: string;
  vetNif?: string;
  vetMembership?: string;
  vetDescription?: string;
  logisticId?: string;
  logisticVehicle?: string;
  logisticMembership?: string;
  logisticCarrier?: string;
  logisticTransportSystem?: string;
  logisticDisinfectionDate?: Date;
  logisticNif?: string;
  logisticAtes?: string;
  logisticSirentra?: string;
  logisticDescription?: string;
  butcherId?: string;
  butcherQuantity?: number;
  butcherDate?: Date;
  butcherDescription?: string;
  farmerId?: string;
  farmerDescription?: string;
}

export enum DocumentsState {
  NONE = 'NONE',
  DISABLED = 'DISABLED',
  SIGNED = 'SIGNED',
}

export const documents_token = new InjectionToken<BaseApiService<DocumentsApiDTO>>('documents api token');
